import '../sass/main.scss';

import '../img/icon-hand-point-down-orange.svg';
import '../img/icon-hand-point-right-orange.svg';
import '../img/icon-hand-point-left-orange.svg';

import '../fonts/ModernEra-Black.woff2';
import '../fonts/ModernEra-BlackItalic.woff2';
import '../fonts/ModernEra-Bold.woff2';
import '../fonts/ModernEra-BoldItalic.woff2';
import '../fonts/ModernEra-Italic.woff2';
import '../fonts/ModernEra-Medium.woff2';
import '../fonts/ModernEra-MediumItalic.woff2';
import '../fonts/ModernEra-Regular.woff2';
import '../fonts/ModernEraMono-Bold.woff2';
import '../fonts/ModernEraMono-Regular.woff2';

import './layouts/employee-handbook-menu.js';
import './common/css-variables.js';

import { initModals } from './common/modals.js';

(() => {
    initModals();
})();
